import { render } from "./UserAnagrafica.vue?vue&type=template&id=52b9096b&scoped=true"
import script from "./UserAnagrafica.vue?vue&type=script&lang=js"
export * from "./UserAnagrafica.vue?vue&type=script&lang=js"

import "./UserAnagrafica.vue?vue&type=style&index=0&id=52b9096b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b9096b"]])

export default __exports__